// ── NEWS BANNER ──
function dismissBanner() {
  const banner = document.getElementById('news-banner');
  if (banner) {
    banner.style.display = 'none';
    document.documentElement.style.setProperty('--banner-h', '0px');
  }
}

// ═══════════════════════════════════════════════
// SAVAGE 3D — Main App JS
// Cart powered by Shopify Ajax API
// ═══════════════════════════════════════════════

// ── NAVIGATION ──
function showPage(name) {
  document.querySelectorAll('.page').forEach(p => p.classList.remove('active'));
  const pg = document.getElementById('page-' + name);
  if (pg) pg.classList.add('active');
  document.querySelectorAll('.nav-links a').forEach(a => a.classList.remove('active'));
  const n = document.getElementById('nav-' + name);
  if (n) n.classList.add('active');
  window.scrollTo(0, 0);
  if (name === 'blog') {
    renderBlog();
    const lv = document.getElementById('blog-list-view');
    const pv = document.getElementById('blog-post-view');
    if (lv) lv.style.display = 'block';
    if (pv) pv.style.display = 'none';
  }
  // re-trigger scroll reveal for new page
  setTimeout(() => {
    document.querySelectorAll('.mach-card,.repair-card,.prod-card,.svc-card,.stat-box').forEach((el, i) => {
      if (el.style.opacity === '0' || !el.style.opacity) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(28px)';
        el.style.transition = `opacity .5s ${i * .05}s, transform .5s ${i * .05}s`;
        obs.observe(el);
      }
    });
  }, 50);
}

function goToProduct(url) {
  window.location.href = url;
}

// ── SHOPIFY AJAX CART ──
async function shopifyAddToCart(variantId, btn) {
  const originalText = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled = true;

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (!res.ok) throw new Error('Failed to add');

    await refreshCart();
    showToast('Added to cart!');
    btn.textContent = '✓ Added';
    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 2000);
  } catch (e) {
    showToast('Error — please try again');
    btn.textContent = originalText;
    btn.disabled = false;
  }
}

async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    updateCartUI(cart);
  } catch (e) {
    console.error('Cart refresh failed', e);
  }
}

async function removeCartItem(key) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    await refreshCart();
  } catch (e) {
    console.error('Remove failed', e);
  }
}

function updateCartUI(cart) {
  // Update count badge
  const count = cart.item_count || 0;
  const countEl = document.getElementById('cart-count');
  if (countEl) countEl.textContent = count;

  // Update total
  const totalEl = document.getElementById('cart-tot');
  if (totalEl) {
    const total = (cart.total_price / 100).toFixed(2);
    totalEl.textContent = '$' + total;
  }

  // Update items list
  const listEl = document.getElementById('cart-list');
  if (!listEl) return;

  if (!cart.items || cart.items.length === 0) {
    listEl.innerHTML = '<p class="cart-empty">// Cart is empty</p>';
    return;
  }

  listEl.innerHTML = cart.items.map(item => `
    <div class="ci">
      <div class="ci-img">
        ${item.featured_image ? `<img src="${item.featured_image.url}" style="width:100%;height:100%;object-fit:cover;" alt="${item.title}"/>` : '🖨️'}
      </div>
      <div class="ci-info">
        <p class="ci-name">${item.title}</p>
        <p class="ci-meta">Qty: ${item.quantity}${item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : ''}</p>
      </div>
      <span class="ci-price">$${(item.final_line_price / 100).toFixed(2)}</span>
      <button class="ci-rm" onclick="removeCartItem('${item.key}')">✕</button>
    </div>
  `).join('');
}

function toggleCart() {
  document.getElementById('cart-modal').classList.toggle('open');
  document.getElementById('cart-overlay').classList.toggle('open');
  // Refresh cart data when opening
  if (document.getElementById('cart-modal').classList.contains('open')) {
    refreshCart();
  }
}

// Checkout button
document.addEventListener('DOMContentLoaded', () => {
  const checkoutBtn = document.querySelector('.checkout-btn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', () => {
      window.location.href = '/checkout';
    });
  }
});

// ── SHOP FILTER (works on Liquid-rendered cards) ──
function filterProds(cat, btn) {
  document.querySelectorAll('.f-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('#shop-grid .prod-card').forEach(card => {
    if (cat === 'all' || card.dataset.cat === cat) {
      card.style.display = '';
    } else {
      card.style.display = 'none';
    }
  });
}

// ── MOBILE NAV (SPA) ──
function toggleSPAMobNav(){
  const nav = document.getElementById('spa-mob-nav');
  const overlay = document.getElementById('spa-mob-overlay');
  const btn = document.getElementById('spa-ham-btn');
  if(nav){ nav.classList.toggle('open'); }
  if(overlay){ overlay.classList.toggle('open'); }
  if(btn){ btn.classList.toggle('active'); }
}
function closeSPAMobNav(){
  const nav = document.getElementById('spa-mob-nav');
  const overlay = document.getElementById('spa-mob-overlay');
  const btn = document.getElementById('spa-ham-btn');
  if(nav) nav.classList.remove('open');
  if(overlay) overlay.classList.remove('open');
  if(btn) btn.classList.remove('active');
}

// File upload replaced with email redirect

// ── TOAST ──
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2600);
}

// ── BLOG ──
const POSTS = [
  {id:1,tag:'Material Guide',date:'May 2026',readtime:'5 min read',title:'PLA vs PETG vs ABS — Which Should You Choose?',excerpt:"Not all filaments are created equal. Here's a straight breakdown of when to use each material and why it matters for your print.",icon:'🧵',color:'rgba(0,212,255,.08)',body:`<p class="post-tag">Material Guide</p><h1 class="post-title">PLA vs PETG vs ABS — Which Should You Choose?</h1><div class="post-meta"><span>May 2026</span><span>5 min read</span></div><div class="post-body"><p>One of the most common questions we get: <strong>which filament should I order in?</strong></p><h2>PLA</h2><p>Most popular. Sharp detail, wide color range. Great for decor, props, prototypes. Not for heat above 60°C.</p><div class="highlight">// Best for: Decor, display models, cosplay props, prototypes.</div><h2>PETG</h2><p>The sweet spot. Tougher, slightly flexible, handles ~80°C. Food-safe when printed correctly.</p><div class="highlight">// Best for: Functional parts, enclosures, outdoor use.</div><h2>ABS</h2><p>High heat resistance, impact tough. Only material we can acetone vapor smooth. Needs enclosed printer.</p><div class="highlight">// Best for: Mechanical parts, high-heat environments, smoothed finishes.</div><h2>Also Available</h2><ul><li><strong>Nylon</strong> — Extremely tough, flexible, low friction. Gears and joints.</li><li><strong>PC</strong> — Strongest we offer. Serious engineering applications.</li><li><strong>TPU</strong> — Flexible rubber-like. Phone cases, gaskets, grip pieces.</li></ul><p>Still unsure? Select <strong>"Not Sure — Advise Me"</strong> on the order form.</p></div>`},
  {id:2,tag:'How We Work',date:'Apr 2026',readtime:'3 min read',title:'What Happens After You Submit a Custom Order',excerpt:"You hit send on the form — then what? Here's exactly what our process looks like from submission to your doorstep.",icon:'⚙️',color:'rgba(255,45,120,.06)',body:`<p class="post-tag">How We Work</p><h1 class="post-title">What Happens After You Submit a Custom Order</h1><div class="post-meta"><span>Apr 2026</span><span>3 min read</span></div><div class="post-body"><p>You fill out the form and hit send. Here's what happens next.</p><h2>Step 1 — We Review</h2><p>Within 1–2 business days we check your file or brief for issues and assess the project.</p><h2>Step 2 — Quote</h2><p>We send you a quote covering material, print time, and post-processing. You approve before anything prints.</p><div class="highlight">// Standard lead time: 2–4 weeks from order confirmation.</div><h2>Step 3 — Print Queue</h2><p>Your job enters the queue. We batch runs when possible for consistency.</p><h2>Step 4 — Quality Check & Ship</h2><p>Every print is inspected before shipping. If it doesn't meet standard, we reprint. Tracking provided.</p></div>`},
  {id:3,tag:'Resin Deep Dive',date:'Mar 2026',readtime:'4 min read',title:"Resin: ABS-Like vs Clear — What's the Difference?",excerpt:'We offer two resin options for high-detail work. Here\'s how they compare and which fits your project.',icon:'🔬',color:'rgba(0,212,255,.05)',body:`<p class="post-tag">Resin Deep Dive</p><h1 class="post-title">Resin: ABS-Like vs Clear</h1><div class="post-meta"><span>Mar 2026</span><span>4 min read</span></div><div class="post-body"><p>The Elegoo Saturn 8K gives us 19.25µm XY resolution — here's how to pick the right resin for your job.</p><h2>ABS-Like Resin</h2><p>Rigid, matte surface, excellent detail. Tougher than standard resin. Great for minis, figurines, molds, display pieces.</p><div class="highlight">// Best for: Minis, figurines, detailed props, molds.</div><h2>Clear Resin</h2><p>Glass-like clarity when properly post-processed. Ideal for light pipes, lenses, transparent enclosures.</p><div class="highlight">// Best for: Light pipes, lenses, transparent decorative pieces.</div><p>Note: Clear resin yellows slightly over time with UV exposure. Store away from direct sunlight.</p></div>`},
  {id:4,tag:'Design Tips',date:'Feb 2026',readtime:'6 min read',title:'How to Prep Your STL File for a Perfect Print',excerpt:"Bad files lead to bad prints. Here's our checklist for making sure your STL is clean, watertight, and ready to slice.",icon:'📐',color:'rgba(255,45,120,.04)',body:`<p class="post-tag">Design Tips</p><h1 class="post-title">How to Prep Your STL for a Perfect Print</h1><div class="post-meta"><span>Feb 2026</span><span>6 min read</span></div><div class="post-body"><p>We offer file repair, but the cleaner the file you send, the faster and cheaper your order.</p><h2>1. Make it Watertight</h2><p>Your mesh needs to be a closed solid. Use Blender's 3D Print Toolbox to check for non-manifold geometry.</p><div class="highlight">// Rule: Every edge shared by exactly two faces. No more, no less.</div><h2>2. Wall Thickness</h2><p>Minimum 1.2mm for structural parts (3 perimeters at 0.4mm nozzle). Thinner and the slicer may skip it entirely.</p><h2>3. Check Scale</h2><p>Export STL in <strong>millimeters</strong>. We've seen files exported in inches that printed 25x too small.</p><ul><li>Blender: Export → STL → Scale 1.0, Units: mm</li><li>Fusion 360: File → 3D Print (auto-sets mm)</li><li>TinkerCAD: Export → .STL (always mm)</li></ul><p>Not sure? Send the file anyway — we check everything before printing.</p></div>`},
];

function makeBlogCard(p) {
  return `<div class="blog-card" onclick="openBlogPost(${p.id})">
    <div class="blog-thumb" style="background:${p.color};">
      <span class="blog-thumb-icon">${p.icon}</span>
      <span class="blog-tag-pill">${p.tag}</span>
      <div class="blog-thumb-bar"></div>
    </div>
    <div class="blog-body">
      <div class="blog-meta"><span>${p.date}</span><span>${p.readtime}</span></div>
      <h3 class="blog-title">${p.title}</h3>
      <p class="blog-excerpt">${p.excerpt}</p>
      <span class="blog-read">Read Post →</span>
    </div>
    <div class="blog-card-overlay"></div>
  </div>`;
}

function renderBlog() {
  const el = document.getElementById('blog-grid');
  if (el) el.innerHTML = POSTS.map(makeBlogCard).join('');
}

function renderHomeBlog() {
  const el = document.getElementById('home-blog-grid');
  if (el) el.innerHTML = POSTS.slice(0, 3).map(makeBlogCard).join('');
}

function openBlogPost(id) {
  const p = POSTS.find(x => x.id === id);
  if (!p) return;
  const lv = document.getElementById('blog-list-view');
  const pv = document.getElementById('blog-post-view');
  if (lv) lv.style.display = 'none';
  if (pv) pv.style.display = 'block';
  const pc = document.getElementById('post-content');
  if (pc) pc.innerHTML = p.body;
  window.scrollTo(0, 0);
}

function closeBlogPost() {
  const lv = document.getElementById('blog-list-view');
  const pv = document.getElementById('blog-post-view');
  if (lv) lv.style.display = 'block';
  if (pv) pv.style.display = 'none';
  window.scrollTo(0, 0);
}

// ── CUSTOM CURSOR ──
const cur = document.createElement('div');
cur.style.cssText = 'position:fixed;width:7px;height:7px;border-radius:50%;background:rgba(0,212,255,.9);pointer-events:none;z-index:99999;transform:translate(-50%,-50%);box-shadow:0 0 10px rgba(0,212,255,.6);transition:width .15s,height .15s;';
document.body.appendChild(cur);
const rng = document.createElement('div');
rng.style.cssText = 'position:fixed;width:26px;height:26px;border-radius:50%;border:1px solid rgba(0,212,255,.35);pointer-events:none;z-index:99998;transform:translate(-50%,-50%);transition:left .08s,top .08s;';
document.body.appendChild(rng);
document.addEventListener('mousemove', e => {
  cur.style.left = e.clientX + 'px'; cur.style.top = e.clientY + 'px';
  rng.style.left = e.clientX + 'px'; rng.style.top = e.clientY + 'px';
});
document.querySelectorAll('a,button,span[onclick],.svc-card,.prod-card,.blog-card').forEach(el => {
  el.addEventListener('mouseenter', () => { cur.style.width = '12px'; cur.style.height = '12px'; });
  el.addEventListener('mouseleave', () => { cur.style.width = '7px'; cur.style.height = '7px'; });
});

// ── SCROLL REVEAL ──
const obs = new IntersectionObserver(es => es.forEach(e => {
  if (e.isIntersecting) {
    e.target.style.opacity = '1';
    e.target.style.transform = 'translateY(0)';
  }
}), { threshold: .1 });

document.querySelectorAll('.svc-card,.prod-card,.stat-box,.blog-card,.mach-card,.repair-card').forEach((el, i) => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(28px)';
  el.style.transition = `opacity .5s ${i * .06}s, transform .5s ${i * .06}s`;
  obs.observe(el);
});

// ── INIT ──
renderHomeBlog();
renderBlog();
refreshCart();

// ── EMAIL ORDER TEMPLATE ──
const ORDER_EMAIL = 'savage3dprinting@gmail.com';

const EMAIL_BODY = `Hi Savage 3D,

I would like to place a custom print order. Here are my details:

--- CONTACT ---
Name: 
Email: 
Phone: 

--- ORDER TYPE ---
[ ] I have a file to print
[ ] I need you to design it for me
[ ] Design + Print (full service)

--- PRINT SPECIFICATIONS ---
Print Type:  [ ] FDM (Filament)   [ ] Resin (High Detail)

Material:
FDM:   [ ] PLA  [ ] PETG  [ ] ABS  [ ] Nylon  [ ] PC  [ ] TPU (Flexible)
Resin: [ ] ABS-Like  [ ] Clear Resin
[ ] Not sure - please recommend

Color: 
Quantity: 
Post-Processing:
[ ] None - Raw Print
[ ] Sanding & Smoothing
[ ] Primed
[ ] Acetone Vapor Smooth (ABS only)

--- PROJECT DESCRIPTION ---
(Dimensions, purpose, design ideas, reference images...)



--- BUDGET ---
Estimated Budget: 

--- FILE ---
[ ] File attached to this email (.STL .OBJ .3MF .STEP)
[ ] No file - please design from my description above
[ ] File too large - WeTransfer link: 

[ ] I understand the lead time is 2-4 weeks from confirmation.

Thanks!`;

function openOrderEmail() {
  const subject = 'Custom Print Order - Savage 3D';
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (isMobile) {
    window.location.href = 'mailto:' + ORDER_EMAIL +
      '?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(EMAIL_BODY);
  } else {
    window.open(
      'https://mail.google.com/mail/?view=cm&to=' + encodeURIComponent(ORDER_EMAIL) +
      '&su=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(EMAIL_BODY),
      '_blank'
    );
  }
}

function openOrderEmailMailto() {
  // Fallback for non-Gmail users on desktop
  window.location.href = 'mailto:' + ORDER_EMAIL +
    '?subject=' + encodeURIComponent('Custom Print Order - Savage 3D') +
    '&body=' + encodeURIComponent(EMAIL_BODY);
}

function openProductEmail(productName) {
  const subject = 'Custom Order - ' + productName + ' - Savage 3D';
  const body = `Hi Savage 3D,\n\nI would like a custom version of: ${productName}\n\n--- CONTACT ---\nName: \nEmail: \nPhone: \n\n--- WHAT I NEED ---\nCustomization details:\n\n\nColor: \nQuantity: \n\n--- MATERIAL ---\nFDM:   [ ] PLA  [ ] PETG  [ ] ABS  [ ] Nylon  [ ] PC  [ ] TPU\nResin: [ ] ABS-Like  [ ] Clear Resin\n[ ] Not sure - please advise\n\n--- FILE ---\n[ ] Attached (.STL .OBJ .3MF)\n[ ] No file needed\n[ ] WeTransfer link: \n\n[ ] I understand the lead time is 2-4 weeks.\n\nThanks!`;
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (isMobile) {
    window.location.href = 'mailto:' + ORDER_EMAIL +
      '?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(body);
  } else {
    window.open(
      'https://mail.google.com/mail/?view=cm&to=' + encodeURIComponent(ORDER_EMAIL) +
      '&su=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(body),
      '_blank'
    );
  }
}


